import React from 'react';
import { PrimaryText } from 'Components/Texts';
import { SubmitError } from 'Components/Fields/SubmitError';
import { CheckboxField } from 'Components/Fields/CheckboxField';
import { useForm } from 'Hooks/useForm';
import './CancelSurveyForm.css';
import { PillButton } from 'Components/Fields/Buttons';

const CancelSurveyForm = ({
  handleContinue,
  handleCheck,
  handleMsg,
  started,
  onFormSubmit,
  completed,
  checkboxOptions = [],
}) => {
  const formName = 'cancelationSurvey';
  const { formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
    onFormStartedTrackingFields: started,
    onFormCompletedTrackingFields: completed,
    alwaysAllowSubmit: true,
  });

  return (
    <form onSubmit={(event) => handleSubmit(event)}>
      <div className="surveyFormContainer">
        <PrimaryText
          alignText="centerText"
          text="We're sorry to see you go. To help us improve the Fox Nation experience, please select the reason(s) why you canceled. Please select all that apply."
        />
        <section className="formInput">
          <ul className="centerChecklist">
            {checkboxOptions.map(({ text }, index) => (
              <CheckboxField id={`cancel-survey-checkbox-${index}`} onCheck={handleCheck} text={text} key={index} />
            ))}
          </ul>
          <div className="textFieldContainer">
            <PrimaryText alignText="centerText" text="Other (please specify):" />
            <textarea className="textField" maxLength="750" onBlur={(event) => handleMsg(event.target.value)} />
          </div>
        </section>

        <SubmitError error={formError} formName={formName} trackError={false} />
        <PillButton
          modernLayout
          type="button"
          className="formSubmit"
          text="Keep My Subscription"
          onClick={handleContinue}
        />
        <PillButton modernLayout className="cancelSubscriptionBtn" text="Cancel Subscription" />
      </div>
    </form>
  );
};

export default CancelSurveyForm;
